import React from 'react';
import cn from 'classnames';

import Close from 'react-scale//components/icons/Close';

import { mq } from 'react-scale/components/website/big/Themes';

const Modal = ({ children, title, show, onClick }) => (
  <div className={cn('main-wrapper', { show })}>
    <div className="wrapper">
      <div className="title">
        <div className="close" onClick={onClick}>
          <Close style={{ width: '100%' }} />
        </div>
        {title && (
          <h5>
            {title}
          </h5>
        )}
      </div>
      <div className="content">{children}</div>
    </div>
    <style jsx>{`
      .main-wrapper {
        background: rgba(255, 255, 255, 0.95);
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        pointer-events: none;
        opacity: 0;
      }
      .main-wrapper.show {
        pointer-events: all;
        opacity: 1;
      }

      .wrapper {
        background: #fff;
        max-width: 90vw;
        max-height: 90vh;
        min-height: 60vh;
        overflow: scroll;
        border-radius: var(--border-radius);
        box-sizing: border-box;
      }
      @media (min-width: ${mq.md}) {
        .wrapper {
          width: 656px;
          max-width: none;
        }
      }
      @media (min-width: ${mq.lg}) {
        .wrapper {
          width: 856px;
        }
      }

      .title {
        position: relative;
        text-align: center;
        padding: calc(2rem / 2) calc(2rem * 2);
        border-bottom: 1px solid #F8FAFC;
      }
      @media (min-width: ${mq.lg}) {
        .title {
          padding: calc(2rem / 2) calc(2rem * 2);
        }
      }

      .close {
        background: #f2f2f2;
        width: 2rem;
        height: 2rem;
        padding: calc(2rem / 5);
        display: flex;
        position: absolute;
        top: calc(50% - 2rem / 2);
        right: calc(2rem / 2);
        cursor: pointer;
        border-radius: 100%;
        box-sizing: border-box;
      }

      .content {
        padding: calc(2rem / 2);
      }
      @media (min-width: ${mq.lg}) {
        .content {
          padding: 2rem;
        }
      }
    `}</style>
  </div>
);

export default Modal;
